export default __webpack_public_path__ + "static/media/banner6-2-resized.222a886a.jpg";